/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SSOEnumItemViewModel } from "../types/SSOEnumItemViewModel.ts";

export const SSOEnumItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("Valor numérico do item de enumeração SSO."),
  ),
  name: z
    .string()
    .describe("Nome descritivo do item de enumeração SSO.")
    .nullish(),
}) as unknown as ToZod<SSOEnumItemViewModel>;
